export default __webpack_public_path__ + "static/media/profile_12.98f04811.jpg";